export function activeShareLink(element, {title, text, url}) {
    const shareData = {
        title: title,
        text: text,
        url: url
    }

    if(element) {
        element.addEventListener('click', async () => {
            try {
                await navigator.share(shareData);
                return true;
            } catch(err) {
            }
        });
    }

    return null;
}